import { render, staticRenderFns } from "./PagePagoPersonal.vue?vue&type=template&id=2cd1950c&"
import script from "./PagePagoPersonal.vue?vue&type=script&lang=js&"
export * from "./PagePagoPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports